import { useTranslation } from "react-i18next";
import { FavoriteDeleteButton } from "./FavoriteDeleteButton";
import { FavoriteEditButton } from "./FavoriteEditButton";
import { v4 as uuidv4 } from "uuid";
import { PAGE_NAME_HOW_TO_FIX } from "../../../../constants/common_constants";
import { IFavoriteInfoType } from "../types/favorite_types";
import { useErrorDialog } from "../../../../hooks";

interface DisPlayFavoriteListProps {
  favoriteInfo: IFavoriteInfoType;
  userId: string;
  showConfirmDialog: (message: string) => void;
  showEditDialog: (titleName: string) => void;
  setFavoriteInfo: React.Dispatch<React.SetStateAction<IFavoriteInfoType>>;
  isLastList: boolean;
}

export const DisPlayFavoriteList: React.FC<DisPlayFavoriteListProps> = ({
  favoriteInfo,
  userId,
  showConfirmDialog,
  showEditDialog,
  setFavoriteInfo,
  isLastList,
}) => {
  //言語切替用
  const { t } = useTranslation();

  // エラーダイアログ
  const { showErrorDialog } = useErrorDialog();

  //お気に入りリストをクリックしたときの処理
  const handleOnFavoriteList = async (reference: string) => {
    try {
      //HowToFix画面に遷移
      const keyId = uuidv4();
      const refKey = `reference_${keyId}`;
      //LocalStorageに型式, タイトル, リンクを保存する
      localStorage.setItem("model", favoriteInfo.model);
      localStorage.setItem("title", favoriteInfo.title);
      localStorage.setItem(refKey, reference);
      //一時的に<a>タグを作成して別タブでリンクを開く
      const link = document.createElement("a");
      link.target = "_blank";
      link.href = `/${PAGE_NAME_HOW_TO_FIX}/${keyId}`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (err) {
      console.log(`[Favorite] handleOnFavoriteList error:`, err);
      // パラメータ不足以外のエラー時にはその場に留まる
      showErrorDialog(
        t("共通エラーポップ.エラー"),
        t("共通エラーポップ.通信エラーが発生しました。")
      ); //エラー", "通信エラーが発生しました。
    }
  };

  return (
    //取得したお気に入り一覧の最後尾のお気に入り情報の場合, 下の余白は付けない
    <div
      className={`relative w-full bg-white border border-gray-500 ${
        !isLastList && "mb-4"
      }`}
    >
      <FavoriteDeleteButton
        showConfirmDialog={showConfirmDialog}
        favoriteInfo={favoriteInfo}
        setFavoriteInfo={setFavoriteInfo}
      />
      <FavoriteEditButton
        showEditDialog={showEditDialog}
        favoriteInfo={favoriteInfo}
        setFavoriteInfo={setFavoriteInfo}
      />
      <div
        className="pl-5 pr-7 py-3"
        onClick={() => handleOnFavoriteList(favoriteInfo.dmcInfo)}
      >
        <p>
          {t("お気に入り画面.型式")} :
          <span className="pl-1">{favoriteInfo.model}</span>
        </p>
        {/* <p className="line-clamp-2">{favoriteInfo.title}</p> */}
        <p>{favoriteInfo.title}</p>
      </div>
    </div>
  );
};
